




























































































import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Getter, Action } from 'vuex-class'

import { projectVariables } from '../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'
import { WEB_PAGE_INFORMATION_LIST } from '../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-2-customer-website-page-information'

import DigitalCurrency1DigitalCurrencySymbol from '../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-1-digital-currency-symbol.vue'
import DigitalCurrency2SendPaymentButton from '../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-2-send-payment-button.vue'
import Input1TextInputForSearch from '../../../html-components-type-1-basic/basic-type-3-input/input-1-text-input-for-search.vue'
import DigitalCurrency20AnimatedCurrencyLabel from '../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-20-animated-currency-label.vue'

const namespace = 'digitalCurrency'

@Component({
  components: {
    DigitalCurrency1DigitalCurrencySymbol,
    DigitalCurrency2SendPaymentButton,
    Input1TextInputForSearch,
    DigitalCurrency20AnimatedCurrencyLabel
  }
})
class Header1 extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any

  @Action('getDigitalCurrencyAccountById', { namespace }) getDigitalCurrencyAccountById?: any
  @Action('getDigitalCurrencyAccountBySearchText', { namespace }) getDigitalCurrencyAccountBySearchText?: any

  projectName: string = projectVariables.projectName
  digitalCurrencyName: string = projectVariables.digitalCurrencyName

  showNavigationDrawer: boolean = false
  // showMenu: boolean = false

  websitePageInformationList = WEB_PAGE_INFORMATION_LIST

  showAccountSearchTextInputField: boolean = false

  get isVisibleTextInputFieldOnMobileDisplay (): boolean {
    return (this.isMobileDevice! && this.showAccountSearchTextInputField)
  }

  async getSearchResultList (searchText: string): Promise<any[]> {
    if (!searchText) { return [] }

    const searchResultList = await this.getDigitalCurrencyAccountBySearchText({
      searchText
    })

    return searchResultList.map((digitalCurrencyAccount: any) => {
      return {
        id: digitalCurrencyAccount.accountId,
        name: `${digitalCurrencyAccount.accountName} (@${digitalCurrencyAccount.accountUsername})`,
        icon: digitalCurrencyAccount.accountProfilePictureUrl
      }
    })
  }

  async selectSearchResult (selectedAccountId: string) {

    if (!selectedAccountId) {
      return
    }

    const digitalCurrencyAccount = await this.getDigitalCurrencyAccountById(selectedAccountId)

    if (!digitalCurrencyAccount) {
      return
    }

    this.$router.push({ name: 'Account', params: {
      accountUsername: digitalCurrencyAccount.accountUsername
    }}).catch((_errorMessage: any) => {
      /* */
    })
  }
}

export default Header1

